"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
var MAX_WIDTH_SECTION = 1800;
var MAX_WIDTH_CONTAINER = 1120;
var MAX_WIDTH_CONTENT = 800;
var sizes = {
    maxWidthSection: "".concat(MAX_WIDTH_SECTION, "px"),
    maxWidthContainer: "".concat(MAX_WIDTH_CONTAINER, "px"),
    maxWidthContent: "".concat(MAX_WIDTH_CONTENT, "px"),
    minWidthEmph: "".concat(MAX_WIDTH_CONTAINER * 1.3, "px"),
};
var breakpoints = {
    mobilePortrait: "320px",
    mobileLandscape: "568px",
    tabletPortrait: "768px",
    tabletLandscape: "992px",
};
var mediaQueries = {
    xsmall: "@media screen and (max-width: ".concat(breakpoints.mobilePortrait, ")"),
    small: "@media screen and (max-width: ".concat(breakpoints.mobileLandscape, ")"),
    medium: "@media screen and (max-width: ".concat(breakpoints.tabletPortrait, ")"),
    large: "@media screen and (max-width: ".concat(breakpoints.tabletLandscape, ")"),
    emphasized: "@media screen and (min-width: ".concat(sizes.minWidthEmph, ")"),
};
exports.theme = {
    MAX_WIDTH_SECTION: MAX_WIDTH_SECTION,
    MAX_WIDTH_CONTAINER: MAX_WIDTH_CONTAINER,
    MAX_WIDTH_CONTENT: MAX_WIDTH_CONTENT,
    sizes: sizes,
    breakpoints: breakpoints,
    mediaQueries: mediaQueries,
};
//# sourceMappingURL=theme.js.map